package com.trevorwiebe.timesheet.core.domain.model

import com.trevorwiebe.timesheet.core.domain.Util.convertStringToLocalDateTime
import com.trevorwiebe.timesheet.core.domain.Util.toIsoStringWithMillis
import com.trevorwiebe.timesheet.core.domain.dto.TimeSheetDto
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone

data class TimeSheet(
    val id: String,
    val confirmedByUser: Boolean,
    val submitted: Boolean,
    val payPeriodStart: LocalDateTime,
    val payPeriodEnd: LocalDateTime,
)

fun TimeSheetDto.toTimeSheet(id: String) = TimeSheet(
    id = id,
    confirmedByUser = confirmedByUser,
    submitted = submitted,
    payPeriodStart = convertStringToLocalDateTime(payPeriodStart),
    payPeriodEnd = convertStringToLocalDateTime(payPeriodEnd),
)

fun TimeSheet.toTimeSheetDto() = TimeSheetDto(
    confirmedByUser = confirmedByUser,
    submitted = submitted,
    payPeriodStart = payPeriodStart.toIsoStringWithMillis(TimeZone.currentSystemDefault()),
    payPeriodEnd = payPeriodEnd.toIsoStringWithMillis(TimeZone.currentSystemDefault())
)